import { render } from "./LandingPage.vue?vue&type=template&id=68a648f9"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.css?vue&type=style&index=0&lang=css"

import exportComponent from "/codebuild/output/src016863213/src/lauracares/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__